<template>
  <div class="container mx-auto m-10">
    <h1 class="text-4xl font-medium text-black text-center sm:text-center sm:text-8xl">Weather App</h1>
  </div>
  
</template>

<script>
  export default {
    name: "Title",
  };
</script>